$(document).ready(function() {
    var isFirstLoad = true;

    // Manejar clic en las pestañas
    $('.tabs-horizontal__header-element').click(function() {
        var tabId = $(this).data('tab');
        var $tabsContainer = $(this).closest('.tabs-horizontal');

        // Ocultar todos los contenidos de las pestañas y remover la clase 'active'
        $tabsContainer.find('.tabs-horizontal__content').removeClass('active').hide();

        // Mostrar el contenido de la pestaña seleccionada y agregar la clase 'active'
        $tabsContainer.find('.tabs-horizontal__content[data-tab="' + tabId + '"]').addClass('active').fadeIn();

        // Remover la clase 'active' de todas las pestañas y agregarla a la pestaña seleccionada
        $tabsContainer.find('.tabs-horizontal__header-element').removeClass('active');
        $(this).addClass('active');

        // Desplazar la página para enfocar el contenido de la pestaña abierta solo si no es la primera carga
        if (!isFirstLoad) {
            $('html, body').animate({
                scrollTop: $(this).offset().top - 200 // Ajustar el desplazamiento según sea necesario
            }, 300); // Duración del desplazamiento en milisegundos
        }
    });

    // Solo abrir la primera pestaña por defecto sin desplazamiento
    // Se asegura de que solo se haga el clic sin desplazar la página
    var firstTab = $('.tabs-horizontal .tabs-horizontal__header-element[data-tab="1"]');
    
    // Mostrar la primera pestaña sin desplazamiento
    var $tabsContainer = firstTab.closest('.tabs-horizontal');
    $tabsContainer.find('.tabs-horizontal__content').removeClass('active').hide();
    $tabsContainer.find('.tabs-horizontal__content[data-tab="1"]').addClass('active').fadeIn();
    $tabsContainer.find('.tabs-horizontal__header-element').removeClass('active');
    firstTab.addClass('active');

    // Marcar que la primera carga ya ha ocurrido
    isFirstLoad = false;
});
